import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Activity } from "lucide-react";
import { fmtBRL, fmtPct, fmtNum } from "@/lib/format";
import { EmptyState } from "@/components/common/StateViews";

export function SalespeopleTable({ rows = [] }) {
  const navigate = useNavigate();
  if (!rows.length) return <EmptyState message="Sem vendedores no período." />;

  return (
    <div className="overflow-x-auto rounded-md border border-border" data-testid="salespeople-table">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className="w-10">#</TableHead>
            <TableHead>Vendedor</TableHead>
            <TableHead className="text-right">Receita</TableHead>
            <TableHead className="text-right">Meta</TableHead>
            <TableHead className="w-[180px]">Atingimento</TableHead>
            <TableHead className="text-right">Pace</TableHead>
            <TableHead className="text-right">Margem</TableHead>
            <TableHead className="text-right">Vendas</TableHead>
            <TableHead className="text-right">Raio-X</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow
              key={r.salesperson_id}
              data-testid={`salesperson-row-${r.salesperson_id}`}
              className="cursor-pointer"
              onClick={() => navigate(`/raiox/${r.salesperson_id}`)}
            >
              <TableCell className="font-num text-muted-foreground">{r.posicao}</TableCell>
              <TableCell className="font-medium text-foreground">{r.name}</TableCell>
              <TableCell className="text-right font-num">{fmtBRL(r.receita)}</TableCell>
              <TableCell className="text-right font-num text-muted-foreground">
                {fmtBRL(r.meta)}
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-2">
                  <Progress value={Math.min(r.atingimento, 100)} className="h-1.5" />
                  <span className="w-12 shrink-0 text-right font-num text-xs text-muted-foreground">
                    {fmtPct(r.atingimento)}
                  </span>
                </div>
              </TableCell>
              <TableCell className="text-right font-num text-muted-foreground">
                {fmtBRL(r.pace)}
              </TableCell>
              <TableCell className="text-right font-num text-muted-foreground">
                {fmtPct(r.margem)}
              </TableCell>
              <TableCell className="text-right font-num text-muted-foreground">
                {fmtNum(r.num_vendas)}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  data-testid={`raiox-button-${r.salesperson_id}`}
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/raiox/${r.salesperson_id}`);
                  }}
                >
                  <Activity className="h-4 w-4 text-primary" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
